<template>
  <MainLayout noContentPadding bgColor="white">
    <template #content>
      <div class="relative w-full flex flex-col items-center px-5 pb-5 pt-10">
        <!-- Gradient Circle -->
        <div class="gradient-circle-background" />
        <!-- Bounty Headshots -->
        <BountyHeadshot 
          v-for="(headshot, index) in bountyHeadshots"
          :key="`bounty-headshot-${index}`"
          :headshotData="headshot"
        />
        <!-- Header -->
        <div class="relative flex flex-col items-center mt-8 z-10" style="width: 450px;">
          <video src="https://publicassets.foreplay.co/coin-160.webm" autoplay muted loop playsinline style="width: 80px; height: 80px;" />
          <BaseText type="heading" size="overline" class="text-text-muted mt-6">
            BOUNTIES
          </BaseText>
          <div class="header-text text-center mt-2.5">
            Work with top Foreplay creators or find your next opportunity
          </div>
          <button class="submit-btn mt-7 px-3 py-1.5 rounded-md" @click="animateComingSoon">
            <BaseText type="label" size="sm" class="text-white">
              Post a Bounty
            </BaseText>
          </button>
          <div ref="comingSoon" class="coming-soon flex items-center gap-1 py-1 pl-1 pr-2 rounded-md bg-neutral-25 mt-3 cursor-default">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 17 16" fill="none">
              <path d="M11.0499 6.65001V5.15001C11.0499 3.74168 9.90823 2.60001 8.4999 2.60001C7.09158 2.60001 5.9499 3.74168 5.9499 5.15001V6.65001M5.3499 13.55H11.6499C12.3126 13.55 12.8499 13.0127 12.8499 12.35V7.85001C12.8499 7.18726 12.3126 6.65001 11.6499 6.65001H5.3499C4.68716 6.65001 4.1499 7.18726 4.1499 7.85001V12.35C4.1499 13.0127 4.68716 13.55 5.3499 13.55Z" 
              stroke="#A4ACB9" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <BaseText type="label" size="xs" class="text-icon-disabled">
              Coming Soon
            </BaseText>
          </div>
        </div>
        <!-- Bounty Cards -->
        <div class="w-full flex flex-col gap-3 pb-6 z-10" style="max-width: 760px; margin-top: 80px;">
          <BountyCard 
            v-for="(bounty, index) in bounties" 
            :key="`bounty-card-${index}`" 
            :bountyInfo="bounty"
            @selected="selectedBounty = bounty"
          />
          <!-- Coming Soon Cards -->
          <div class="relative w-full flex flex-col gap-3">
            <div v-for="i in 2" :key="`coming-soon-card-${i}`" class="w-full flex items-center justify-center border border-border-normal" 
            style="height: 200px; border-radius: 20px;">
              <div v-if="i === 1" class="flex items-center gap-1">
                <ComingSoonIcon class="text-icon-normal opacity-60" />
                <BaseText type="label" size="sm" class="text-text-normal opacity-60">
                  Public community bounties coming soon...
                </BaseText>
              </div>
            </div>
            <!-- Fade overlay -->
            <div class="absolute w-full bottom-0 bg-gradient-to-b from-transparent to-white z-10" style="height: 200px" />
          </div>
        </div>
      </div>
      <BountyDrawer 
        v-if="selectedBounty"
        :bounty="selectedBounty"
        @close="selectedBounty = null"
      />
    </template>
  </MainLayout>
</template>

<script>
import MainLayout from '../../layouts/MainLayout.vue'
import BountyCard from '../../components/bounties/BountyCard.vue'
import BountyDrawer from '../../components/bounties/BountyDrawer.vue'
import BountyHeadshot from '../../components/bounties/BountyHeadshot.vue'

import ComingSoonIcon from '../../components/globals/Icons/ComingSoonIcon.vue'
import * as HeadshotPlatforms from '../../components/globals/Icons/BountyHeadshotPlatforms'

const bounties = [
  {
    title: 'Build & Share a workflow using the Foreplay API',
    description: 'We are awarding one member from the community who creates the coolest AI workflow using the Foreplay API. This bounty is completely platform agnostic so use Gumloop, N8N or whatever your heart desires. Share it with the community and get rewarded!',
    payout: 5000,
    dueDate: '2025-10-31',
    status: 'active',
    creator: {
      name: 'Zachary Murray',
      handle: '@foreplayzach',
      avatar: 'https://publicassets.foreplay.co/zach_murray.png'
    }
  }
]

const bountyHeadshots = [
  {
    headshot: 'https://publicassets.foreplay.co/bounty-headshots/bounty-headshot-1.png',
    label: 'n8n Expert',
    platformIcon: HeadshotPlatforms.N8NIcon,
    position: { x: -365, y: 44}
  },
  {
    headshot: 'https://publicassets.foreplay.co/bounty-headshots/bounty-headshot-2.png',
    label: 'Video Editor',
    platformIcon: HeadshotPlatforms.AdobePremiereIcon,
    position: { x: -426, y: 260 }
  },
  {
    headshot: 'https://publicassets.foreplay.co/bounty-headshots/bounty-headshot-3.png',
    label: 'Designer',
    platformIcon: HeadshotPlatforms.FigmaIcon,
    position: { x: 365, y: 44}
  },
  {
    headshot: 'https://publicassets.foreplay.co/bounty-headshots/bounty-headshot-4.png',
    label: 'Creative Strategist',
    platformIcon: HeadshotPlatforms.MetaIcon,
    position: { x: 426, y: 260 }
  }
]

export default {
  name: 'BountiesView',
  components: {
    MainLayout,
    BountyCard,
    BountyDrawer,
    BountyHeadshot,
    ComingSoonIcon
  },
  data () {
    return {
      bounties,
      selectedBounty: null,
      bountyHeadshots
    }
  },
  methods: {
    animateComingSoon () {
      const ref = this.$refs.comingSoon
      ref.classList.add('animate')
      setTimeout(() => { ref.classList.remove('animate') }, 300)
    }
  }
}
</script>

<style scoped>
.bounty-coin-left {
  position: absolute;
  top: 224px;
  left: 0;
}

@property --submit-btn-opacity-1 {
syntax: '<number>';
initial-value: 0.12;
inherits: false;
}
@property --submit-btn-opacity-2 {
  syntax: '<number>';
  initial-value: 0.12;
  inherits: false;
}
.submit-btn {
  --submit-color: #121212;
  background: linear-gradient(180deg, rgba(255, 255, 255, var(--submit-btn-opacity-1)) 0%, rgba(255, 255, 255, var(--submit-btn-opacity-2)) 100%), var(--submit-color);
  color: white;
  box-shadow: 0px -1px 12px 0px rgba(255, 255, 255, 0.12) inset, 0px 0px 0px 1px var(--submit-color);
  transition: box-shadow 100ms ease-in-out,
    color 100ms ease-in-out, 
    background-color 100ms ease-in-out,
    --submit-btn-opacity-1 100ms ease-in-out, 
    --submit-btn-opacity-2 100ms ease-in-out,
    --submit-color 100ms ease-in-out;
}
.submit-btn:hover {
  --submit-btn-opacity-1: 0.24;
  --submit-btn-opacity-2: 0;
}

.coming-soon {
  position: relative;
}
.coming-soon.animate {
  animation: shakeComingSoon 0.3s ease-in-out;
}
@keyframes shakeComingSoon {
  0% { transform: translateX(0px); background-color: #F6F8FA; }
  33% { transform: translateX(5px); }
  50% { background-color: #ECEFF3; }
  66% { transform: translateX(-5px); }
  100% { transform: translateX(0px); background-color: #F6F8FA; }
}

.gradient-circle-background {
  position: absolute;
  width: 668px;
  height: 668px;
  border-radius: 50%;
  top: -36px;
  background: linear-gradient(to bottom, #F6F8FA 0%, #FFF 100%);
  /* background-color: black; */
}

.header-text {
  font-feature-settings: 'ss01' on, 'cv10' on, 'liga' off, 'calt' off;
  font-family: Inter;
  font-size: 25px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px; /* 112% */
}
</style>